import { TPage, IStep } from '../../types/helper';

/**
 * Этапы продажи квартиры - для каждого отдельная страница
 */
export const STEPS: IStep[] = [
  {
    page: 'start' as TPage,
    title: 'С чего начать ?',
    body: 'Как подготовить квартиру к продаже, оценить рынок и собрать материалы для объявления',
  },
  {
    page: 'ad' as TPage,
    title: 'Подача объявления',
    body: 'Как разместить идеальное объявление на ЦИАН и к чему нужно быть готовым после публикации',
  },
  {
    page: 'show' as TPage,
    title: 'Звонки и показы',
    body: 'Как подготовить квартиру к показам и как вести себя с потенциальными покупателями',
  },
  {
    page: 'before-deal' as TPage,
    title: 'Подготовка к сделке',
    body: 'Как долго делаются документы и к каким трудностям при оформлении следует подготовиться',
  },
  {
    page: 'deal' as TPage,
    title: 'Сделка',
    body: 'Какие проверки стоит заказать, как выбрать банк и юриста и зарегистрировать собственность',
  },
  // {
  //   page: 'after-deal' as TPage,
  //   title: 'После сделки',
  //   body: 'Какие налоги нужно платить после продажи квартиры ',
  // },
];
